import type { EChartsOption } from 'echarts';
import { EChart } from '@components/charts';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  points?: Array<[number, number, number, string?]>;
}

/**
 * Simple scatter-on-cartesian "map" placeholder. To render an actual geo map,
 * import an ECharts geo map JSON (e.g., world.json) and call echarts.registerMap.
 */
function MapWidget({ instance }: WidgetRenderProps<Config>) {
  const points = instance.config.points ?? [
    [-74, 40, 100, 'New York'],
    [-0.1, 51.5, 80, 'London'],
    [139.7, 35.7, 90, 'Tokyo'],
    [151.2, -33.9, 40, 'Sydney'],
    [77.2, 28.6, 70, 'Delhi'],
  ];

  const option: EChartsOption = {
    tooltip: { trigger: 'item', formatter: (p: any) => `${p.data[3]}: ${p.data[2]}` },
    grid: { left: 40, right: 20, top: 20, bottom: 30, containLabel: true },
    xAxis: { type: 'value', min: -180, max: 180, name: 'Lng', splitLine: { show: false } },
    yAxis: { type: 'value', min: -90, max: 90, name: 'Lat', splitLine: { show: false } },
    series: [
      {
        type: 'scatter',
        symbolSize: (val: number[]) => Math.max(6, val[2] / 5),
        data: points.map((p) => [p[0], p[1], p[2], p[3]]),
      },
    ],
  };
  return <EChart option={option} />;
}

export const mapWidgetDef: WidgetDefinition<Config> = {
  type: 'map',
  name: 'Map',
  description: 'Geographic points',
  icon: 'GlobalOutlined',
  category: 'chart',
  defaultTitle: 'Map',
  defaultConfig: {},
  minW: 4,
  minH: 4,
  defaultW: 6,
  defaultH: 6,
  component: MapWidget,
  settingsSchema: {
    fields: [{ key: 'points', label: 'Points JSON [[lng,lat,size,label]]', type: 'json' }],
  },
};
